import { j as i } from "../../jsx-runtime-C5mzlN2N.js";
import { N, a as m } from "../../NotificationList-DGxPKGSY.js";
import { u, N as l } from "../../hooks-DVuc7it1.js";
import { a as A } from "../../hooks-DVuc7it1.js";
const d = 8e3, v = (e) => {
  const {
    children: s,
    className: n,
    position: o = "bottom-left",
    autoHideDuration: r = d
  } = e, {
    enqueueNotification: c,
    removeAllNotifications: f,
    notificationList: t
  } = u({
    autoHideDuration: r
  });
  return /* @__PURE__ */ i.jsxs(
    l.Provider,
    {
      value: {
        enqueueNotification: c,
        removeAllNotifications: f
      },
      children: [
        s,
        t.length > 0 && /* @__PURE__ */ i.jsx(
          N,
          {
            className: n,
            position: o,
            children: t.map((a) => /* @__PURE__ */ i.jsx(
              m,
              {
                ...a,
                position: o
              },
              a.id
            ))
          }
        )
      ]
    }
  );
};
export {
  v as default,
  A as useNotification
};
